import type { ReactNode } from 'react';

export function KeyValue({ k, v, mono }: { k: string; v: ReactNode; mono?: boolean }) {
  return (
    <div className="kv-row">
      <span className="kv-k">{k}</span>
      <span className={`kv-v ${mono ? 'mono' : ''}`}>{v}</span>
    </div>
  );
}
